import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DatePipe } from '@angular/common';
import { MapaService } from './../../../../services/mapa.service';
import { Micromedidor } from './../../../../../../_entities/micromedidores/micromedidor';
import { DxDataGridComponent } from 'devextreme-angular';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MicromedidoresService } from './../../../../services/micromedidores.service';
import { StreetViewComponent } from '../../street-view/street-view.component';
import { HistoricoMedicionesMicromedidorComponent } from '../historico-mediciones-micromedidor/historico-mediciones-micromedidor.component';
import { Service, Customer } from './app.service';/*este es una prueba del demo*/
import { User } from '../../../../../../_entities/User'; /*este es una prueba del demo*/
import { AuthService } from '../../../../../auth/auth.service'; /*este es una prueba del demo*/

@Component({
	selector: 'kt-informacion-micromedidor',
	templateUrl: './informacion-micromedidor.component.html',
	styleUrls: ['./informacion-micromedidor.component.scss'],
	providers: [Service],/*este es una prueba del demo*/
})
export class InformacionMicromedidorComponent implements OnInit {
	_user: User;
	public usuarioDemo: boolean = true;
	customers: Customer[];/*este es una prueba del demo*/
	@ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent
	public micromedidorId: number;
	public micromedidor;
	public applyFilterTypes: any;
	public currentFilter: any;
	public showFilterRow: boolean;
	public showHeaderFilter: boolean;
	public direccion: string;
	public usuario;
	public fechaHora;
	public imagen;
	public imagenDemo;

	public geocercaAsignada: string = '';

	constructor(private micromedidoresService: MicromedidoresService, service: Service /*este es una prueba del demo*/,private auth: AuthService /*este es una prueba del demo*/,
		private dialogRef: MatDialogRef<InformacionMicromedidorComponent>,
		private dialog: MatDialog,
		private mapaService: MapaService,
		private datePipe: DatePipe,
		@Inject(MAT_DIALOG_DATA) public data: Micromedidor) { 
			this.customers = service.getCustomers();/*este es una prueba del demo*/
		}

	ngOnInit() {
		// this.obtenerDatosMicromedidor(this.data); original
		// demo
		this._user = this.auth.getUser();
		if(this._user.id === "6cac2e07-cb6d-4725-93d7-ed7ad39f5ade"){
			this.usuarioDemo = false;
			this.obtenerDatosMicromedidorDemo(this.data);
		}else{
			this.obtenerDatosMicromedidor(this.data);
		}
		// demo
	}

	obtenerDatosMicromedidor(micromedidor) {
		this.imagen = this.data.imagen;

		if (micromedidor.geocercas.length > 0) {
			micromedidor.geocercas.forEach(geocerca => {
				this.geocercaAsignada = this.geocercaAsignada + geocerca.nombre + ', ';
			});

			this.geocercaAsignada = this.geocercaAsignada.slice(0, -1);
			this.geocercaAsignada = this.geocercaAsignada.slice(0, -1);

		} else {
			this.geocercaAsignada = 'Sin asignación';
		}

		this.micromedidor = micromedidor;
	}

	obtenerDatosMicromedidorDemo(micromedidor) {
		/*esta es una prueba del demo*/
		this.imagenDemo = './assets/image/garzaimage.jpg'
		/*esta es una pruea del demo*/
	}


	ubicarMedidor() {
		this.mapaService.verMedidor(this.micromedidor);
		this.dialogRef.close()
	}

	ubicarMedidorDemo() {
		this.mapaService.verMedidorDemo(this.micromedidor);
		this.dialogRef.close()
	}

	verHistorico() {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.width = "58%";
		dialogConfig.closeOnNavigation = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.panelClass = 'custom-modalbox';
		dialogConfig.data = this.micromedidor;
		this.dialog.open(HistoricoMedicionesMicromedidorComponent, dialogConfig);
		this.dialogRef.close()
		// this.dialog.open(HistoricoMedicionesMicromedidorComponent);/*este es una prueba del demo*/
	}

	verHistoricoDemo() {
		// const dialogConfig = new MatDialogConfig();
		// dialogConfig.autoFocus = true;
		// dialogConfig.disableClose = true;
		// dialogConfig.width = "58%";
		// dialogConfig.closeOnNavigation = true;
		// dialogConfig.hasBackdrop = false;
		// dialogConfig.panelClass = 'custom-modalbox';
		// dialogConfig.data = this.micromedidor;
		// this.dialog.open(HistoricoMedicionesMicromedidorComponent, dialogConfig);
		this.dialogRef.close()
		this.dialog.open(HistoricoMedicionesMicromedidorComponent);/*este es una prueba del demo*/
	}

	verCalle() {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.width = "40%";
		dialogConfig.closeOnNavigation = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.panelClass = 'custom-modalbox';
		dialogConfig.data = this.data;
		this.dialog.open(StreetViewComponent, dialogConfig)
		this.dialogRef.close()
	}

	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}

}
